import { useSelector } from 'react-redux'
import { Input } from 'antd'
import {
  faGlobe,
  faIdBadge,
  faIdCard,
  faLocationArrow,
  faPhone
} from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import FormItem from '../../../../Components/shared/Forms/FormItem'
import { School, SchoolProperties } from '../../../../utils/entities/school'
import CountriesSelector from '../../../../Components/shared/Selectors/CountriesSelector'
import { getIdOrNull } from '../../../../utils'

const { ABBREVIATION, ADDRESS, COUNTRY, NAME, PHONE_NUMBER } = SchoolProperties

const SchoolForm = ({ errorFields = [], countries, data, displayTitle, onChange }) => {
  const t = useSelector(selectTranslate)

  const handleChange = key => value => onChange(new School({ ...data, [key]: value }))
  const handleEventChange = key => e => onChange(new School({ ...data, [key]: e.target.value }))

  const className = field => errorFields.includes(field) ? 'error-ant-border' : ''

  return (
    <>
      {displayTitle && <h3 className='pdl-12'> {t('common.school')}</h3>}

      <div className='pd-12'>
        <FormItem icon={faIdCard} label='common.name.dd' required>
          <Input
            className={className(NAME)}
            value={data[NAME] ?? null}
            onChange={handleEventChange(NAME)}
          />
        </FormItem>
        <FormItem icon={faIdBadge} label='common.abbreviation.dd' required>
          <Input
            className={className(ABBREVIATION)}
            value={data[ABBREVIATION] ?? null}
            onChange={handleEventChange(ABBREVIATION)}
          />
        </FormItem>
        <FormItem icon={faLocationArrow} label='common.address.dd' required>
          <Input
            className={className(ADDRESS)}
            value={data[ADDRESS] ?? null}
            onChange={handleEventChange(ADDRESS)}
          />
        </FormItem>
        <FormItem icon={faGlobe} label='common.country.dd' className={className(COUNTRY) + ' form-select'} required>
          <CountriesSelector
            countries={countries}
            multiple='default'
            values={getIdOrNull(data[COUNTRY]) ?? null}
            onChange={handleChange(COUNTRY)}
          />
        </FormItem>
        <FormItem icon={faPhone} label='common.phone_number.dd'>
          <Input
            className={className(PHONE_NUMBER)}
            value={data[PHONE_NUMBER] ?? null}
            onChange={handleEventChange(PHONE_NUMBER)}
          />
        </FormItem>
      </div>
    </>
  )
}

export default SchoolForm
